import { nanoid } from "nanoid";
import { formatUnits, parseEther, parseUnits } from "viem";
export const formValuesToCommands = (values) => {
    const { network: { id: chainId }, accountAddress, wrapAmountInUnits, enableAutoWrap, flowRate, paymentOptionWithTokenInfo: { paymentOption, superToken, underlyingToken: underlyingTokenInfo, }, } = values;
    const superTokenAddress = superToken.address;
    const commands = [];
    const isWrapperSuperToken = superToken.extensions.superTokenInfo.type === "Wrapper";
    const _isNativeAssetSuperToken = superToken.extensions.superTokenInfo.type === "Native Asset";
    // TODO(KK): Clean-up the bangs.
    if (isWrapperSuperToken) {
        const underlyingToken = isWrapperSuperToken
            ? {
                isNativeAsset: false,
                address: superToken.extensions.superTokenInfo.underlyingTokenAddress,
                decimals: underlyingTokenInfo.decimals,
            }
            : {
                isNativeAsset: true,
                address: undefined,
                decimals: underlyingTokenInfo.decimals,
            };
        const amountWeiFromUnderlyingTokenDecimals = parseUnits(wrapAmountInUnits, underlyingToken.decimals);
        const amountWeiFromSuperTokenDecimals = parseUnits(wrapAmountInUnits, 18); // Super Tokens always have 18 decimals.
        if (amountWeiFromUnderlyingTokenDecimals !== 0n) {
            commands.push({
                id: nanoid(),
                type: "Wrap into Super Tokens",
                chainId: chainId,
                superTokenAddress,
                accountAddress,
                underlyingToken,
                amountInUnits: formatUnits(amountWeiFromUnderlyingTokenDecimals, underlyingToken.decimals),
                amountWeiFromUnderlyingTokenDecimals,
                amountWeiFromSuperTokenDecimals,
            });
        }
        if (enableAutoWrap && underlyingToken?.address) {
            commands.push({
                id: nanoid(),
                type: "Enable Auto-Wrap",
                chainId: chainId,
                superTokenAddress,
                accountAddress,
                underlyingTokenAddress: underlyingToken.address,
            });
        }
    }
    commands.push({
        id: nanoid(),
        type: "Subscribe",
        chainId,
        superTokenAddress,
        accountAddress,
        receiverAddress: paymentOption.receiverAddress,
        transferAmountWei: parseEther(paymentOption.transferAmountEther ?? "0"),
        flowRate: {
            amountWei: parseEther(flowRate.amountEther),
            period: flowRate.period,
            modifyBehaviour: values.modifyFlowRateBehaviour,
        },
        userData: paymentOption.userData ?? "0x",
    });
    return Object.freeze(commands);
};
